import React, { memo, useCallback } from 'react'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'
import { useTranslation, Trans } from 'react-i18next'
import { useHistory } from 'react-router'

import styles from '../styles'
import { TBannerProps, EAppStateActionTypes } from 'models'
import { StoreValue } from 'store'

const useStyles = makeStyles(styles)

const BannerView: React.FunctionComponent<TBannerProps> = ({
	storeDispatch,
}) => {
	const history = useHistory()
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const goToCompanies = useCallback(() => {
		history.push(`/${i18n.language}/search/employers`, {
			seeEmployersAndTeamsSection: true, // this state is for preserving the 'See employers' and 'Team' on refreshing page
		})
		storeDispatch &&
			storeDispatch({
				type: EAppStateActionTypes.updateSearchSection,
				section: 'employers',
			})
	}, [i18n.language, history, storeDispatch])

	return (
		<div className={classNames(classes.container, classes.bannerContainer)}>
			<Typography
				variant="h5"
				gutterBottom
				className={classNames(classes.h5, classes.fontSize24)}
			>
				{'Make Mondays Happy! '}
			</Typography>
			<Typography
				variant="h6"
				gutterBottom
				className={classNames(classes.h6, classes.fontSize12)}
			>
				<Trans i18nKey="">
					Don’t just find a job, find a team where you belong.
				</Trans>
			</Typography>
			<Chip
				label={t('Explore Employers')}
				clickable={true}
				onClick={goToCompanies}
				className={classNames(classes.exploreTeams, classes.fontSize12)}
				classes={{
					label: classes.label,
				}}
				variant="outlined"
			/>
		</div>
	)
}

const Banner = (props: any) => (
	<StoreValue keys={['storeDispatch']}>
		<BannerView {...props} />
	</StoreValue>
)

export default memo(Banner)
